<template>
    <div>
        <navbar></navbar>
        <div class="__homebg">
            <div class="container">
                <div class="row __flexsmail">
                    <div class="col-lg-7 col-md-7 col-sm-7 __mobidown">
                        <p class="__welf">Welcome to findworka</p>
                        <p class="__welf1">Hire Africa's  top<br> Tech Talents</p>
                        <p class="__welf2">Findworka is an elite network of pre-vetted African software developers who are tested, graded and effectively matched with our partners in an integrated talent and project management freamwork</p>
                        <!-- <p class="__welf2">Findworka is a fast-growing network of Africa's finest tech talents being effectively matched with the most ambitious companies and projects in an integrated talent and project management ecosystem.</p> -->
                        <div class="__toplink">
                            <router-link class="btn __linkbtn" to="/build">Build Your Product</router-link>
                            &nbsp;&nbsp;
                            <router-link class="btn __linkbtn1" to="/hire">Hire Talents</router-link>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 __mobiup">
                        <img src="../assets/img/map.svg" class="img-responsive">
                    </div>
                </div>
            </div>
            <div class="__topcont"></div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7">
                    <p class="__hirep">Hire from our pool of talents</p>
                    <p class="__hirep1">Extend your team by hiring from our pool of topnotch tech talents and experience the best delivery on your projects.</p>

                    <div id="carousel-example-generic" class="carousel slide" data-ride="carousel" data-interval="false" >
                        <ol class="carousel-indicators"></ol>
                        <div class="carousel-inner __carousel-innert">
                            <div class="item active">
                                <div class="__caroimg"></div>
                            </div>
                            <div class="item">
                                <div class="__caroimg1"></div>
                            </div> 
                            <div class="item">
                                <div class="__caroimg2"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-9 col-md-9 col-sm-8 col-xs-6">
                                <a class="left carousel-control __carousel-controlt" href="#carousel-example-generic" data-slide="prev">
                                    <span><i class="fas fa-caret-left"></i></span>
                                </a>
                                <a class="right carousel-control __carousel-controlt" href="#carousel-example-generic" data-slide="next">
                                    <span><i class="fas fa-caret-right"></i></span>
                                </a>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                                <router-link class="__sthringlink" to="/hire">Start hiring <img src="../assets/img/right-arrow.svg"></router-link>
                                <!-- <a href="https://hire.findworka.com" target="_blank" class="__sthringlink">Start hiring <img src="../assets/img/right-arrow.svg"> </a> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5">
                    <div class="row __rowt">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="__fodisp">
                                <i class="__icon fas fa-cube"></i>
                                <p class="__hidep">Frontend</p>
                            </div>
                            <p class="__hidep1">React Js<br> Angular Js<br> Vue Js<br>Flutter</p>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="__fodisp">
                                <i class="__icon fas fa-code"></i>
                                <p class="__hidep">Backend</p>
                            </div>
                            
                            <p class="__hidep1">NodeJs<br>PHP<br>Python<br>Kotlin</p>
                        </div>
                    
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="__fodisp">
                                <i class="__icon fas fa-palette"></i>
                                <p class="__hidep">Mobile</p>
                            </div>
                            
                            <p class="__hidep1">Java<br>Swift<br>React Native<br>Flutter</p>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="__fodisp">
                                <i class="__icon fas fa-mobile-alt"></i>
                                <p class="__hidep">Data Engineering</p>
                            </div>
                            
                            <p class="__hidep1">Python<br>SQL<br>Power BI<br>Tableau</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
			<div class="row">
				<div class="col-lg-4 col-md-4 col-sm-4 p-0">
					<router-link to="/build"><div class="__ourproductimg">
						<p class="__ourproduct1">Outsourced Product Development</p>
                        <p class="__ourproduct2">Let's build for you <img src="../assets/img/right-arrow1.svg"> </p>
					</div></router-link>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <router-link to="/hire"><div class="__ourproductimg2">
						<p class="__ourproduct1">Talent Recruitment</p>
                        <p class="__ourproduct2">Hire talents <img src="../assets/img/right-arrow1.svg"> </p>
					</div></router-link>
					
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4 p-0">
					<router-link to="/pro"><div class="__ourproductimg1">
						<p class="__ourproduct1">Apply as a Talent</p>
                        <p class="__ourproduct2">Become a findworka pro <img src="../assets/img/right-arrow1.svg"> </p>
					</div></router-link>
				</div>
            </div>
		</div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Our Services</p>
                <p class="__wedop1">Findworka builds amazing software products, whether it is just an MVP or the nth version of your platform.<br> We also supply development talents for your contract and full-time position.</p>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <i class="__icond fas fa-users"></i>
                        <p class="__hidep">Recruitment & Talent Outsourcing</p>
                        <p class="__hidep1">Build or expand your tech team by doing a one-off recruitment or by using our talent outsourcing service.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <i class="__icond fas fa-code"></i>
                        <p class="__hidep">Product Development</p>
                        <p class="__hidep1">Whatever application we have the guys skilled for it. Take your project from start to finish and ensure that you have a world-class product.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <i class="__icond fas fa-clock"></i>
                        <p class="__hidep">Training</p>
                        <p class="__hidep1"><a href="https://jointechcampus.com/" target="_blank">Techcampus</a> Africa offers beginner-friendly, and practical trainings that help our students get hired and build a rewarding tech career.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="__countbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__contp text-center">280+</p>
                        <p class="__contp1 text-center">Number of clients <br> we work with.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__contp text-center">10,000+</p>
                        <p class="__contp1 text-center">Number of professionals in<br> our PRO network.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__contp text-center">500+</p>
                        <p class="__contp1 text-center">Number of hired developers<br>and designers.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="__flotbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="__bouncdiv hidden-xs">
                            <img src="../assets/img/GLORY.png" class="__bounceimg">
                            <img src="../assets/img/IRENE.png" class="__bounceimg1">
                            <img src="../assets/img/MUTIAT.png" class="__bounceimg2">
                            <img src="../assets/img/oyin.png" class="__bounceimg3">
                            <img src="../assets/img/wilfred.png" class="__bounceimg4">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__fsignpro text-center">Sign up as our Pro</p>
                        <p class="__fsignpro1 text-center">By becoming a Findworka Pro, you get premium access to the best software design and development projects.</p>
                        <p class=" text-center"><router-link to="/pro" class="btn __fsibtn">Become our pro <img src="../assets/img/right-arrow-top1.svg"></router-link></p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="__bouncdiv hidden-xs">
                            <img src="../assets/img/abimbola.png" class="__bounceimg5">
                            <img src="../assets/img/BOYE.png" class="__bounceimg6">
                            <img src="../assets/img/TEMIDAYO.png" class="__bounceimg7">
                            <img src="../assets/img/CHUCKS.png" class="__bounceimg8">
                            <img src="../assets/img/SHOLA.png" class="__bounceimg9">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="__abbg">
            <div class="container">
                <div class="row __flexsmail">
                    <div class="col-lg-8 col-md-8 col-sm-8 __mobidown">
                        <div class="__inabbg">
                            <p class="__abp">About our team</p>
                            <p class="__abp1">Our team is made up of affable, competent people who are passionate about building software products and helping ambitious people and companies succeed. We are smart, talented, and sure do know how to have fun!</p>
                            <router-link to="/pro" class="btn __ablink">Join Us </router-link>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 __mobiup">
                        <div class="__ouabimg1"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <p class="__hirep">Clients & Friends</p>
            <p class="__hirep1">Meet some of our friends and partners from around the world</p>
            <div class="__logflx">
                <!-- <img src="../assets/img/tracka.png" class="__clifriimg __neclif"> -->
                <!-- <img src="../assets/img/logoeko.png" class="__clifriimg"> -->
                <img src="../assets/img/DSN-Logo.png" class="__clifriimg">
                <img src="../assets/img/BudgIT.png" class="__clifriimg">
                <img src="../assets/img/civic.png" class="__clifriimg">
                <!-- <img src="../assets/img/Layer5.png" class="__clifriimg __neclif"> -->
                <img src="../assets/img/CCHUB.png" class="__clifriimg">
                <!-- <img src="../assets/img/eko360.png" class="__clifriimg __neclif"> -->
                <!-- <img src="../assets/img/followm.png" class="__clifriimg"> -->
                <img src="../assets/img/riby.png" class="__clifriimg __neclif">
                <img src="../assets/img/lifebank.png" class="__clifriimg">
            </div>
            
        </div>

        <div class="__budbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-8">
                        <p class="__wedop">Building the next generation<br> of tech talents</p>
                    </div>
                </div>
                
                
                <div class="row">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <p class="__wedop1">Techcampus Africa offers beginner-friendly, and practical trainings that help our students get hired and build a rewarding tech career.</p>
                        <router-link to="/academy" class="btn __joinlink">Join our academy</router-link>
                    </div>
                    <div class="col-xl-7 col-lg-7 col-md-7">
                        <div class="__fdacad">
                            <div class="__updiv">
                                <img src="../assets/img/build.png" class="__updowimg">
                            </div>
                            <div class="__downdiv">
                                <img src="../assets/img/testwd.jpeg" class="__updowimg">
                            </div>
                            <div class="__updiv">
                                <img src="../assets/img/build2.png" class="__updowimg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="__prodbg">
            <div class="container">
                <p class="__ourpro">Our products</p>
                <p class="__ourpro1">We are empowering today’s companies with the technologies needed to succeed in the evolving digital economy. Check out our latest products</p>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="__prodcard">
                            <p class="__prodp">Kostoma</p>
                            <p class="__prodp1">A productivity tool to make your<br> people and business succeed faster.</p>
                            <p class="__prodplink"><a href="" target="blank">View platform <img src="../assets/img/right-arrow-black.svg"></a></p>
                            <img src="../assets/img/kostoma.png" class="img-responsive">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="__prodcard1">
                            <p class="__prodp">Horus</p>
                            <p class="__prodp1">Horus has a team builder, talent on-boarding and shortlist, and project management assistant that helps to guarantee fulfillment for all your technical projects.</p>
                            <p class="__prodplink"><a href="https://horus.findworka.com/" target="blank">View platform <img src="../assets/img/right-arrow-black.svg"></a></p>
                            <img src="../assets/img/Dashboard.png" class="img-responsive">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="container">
            <!-- <p class="__testip">Testimonials</p><br>
            <carousel class="__slidtop" :autoplay="true" :nav="true" :items="2" :autoplayHoverPause="true" :dots="false" :margin="15" :loop="true" :autoplayTimeout="2000" :responsive="{0:{items:1,nav:false},600:{items:1,nav:false},768:{items:2,nav:false},1024:{items:2,nav:true}}">
                <div class="__tescard">
                    <p class="__tesp">Findworka Pros are very competent, committed and have worked on some of our projects. You don’t meet devs like them everyday. They make tech outsourcing look super.</p>
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <img src="../assets/img/Bosun_findworka.jpg" class="__tesimg">
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                            <p class="__tesp1">Dr. 'Bosun Tijani</p>
                            <p class="__tesp2">Minister of Communications, Innovation and Digital Economy, Federal Republic of Nigeria. </p>
                        </div>
                    </div>
                </div>
                <div class="__tescard1">
                    <p class="__tesp">I have used Findworka and I can boldly vouch for their freelancers. It is easy to connect with them and they deliver on time.</p>
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <img src="../assets/img/seun_findworka.jpg" class="__tesimg">
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                            <p class="__tesp1">Oluseun Onigbinde</p>
                            <p class="__tesp2">Co-founder, Budgit</p>
                        </div>
                    </div>
                </div>
                <div class="__tescard2">
                    <p class="__tesp">My first major gig on Findworka brought in N200,000 in one week. The platform is absolutely amazing for those looking to earn more at their own convenience.</p>
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <img src="../assets/img/Andyson_findworka.png" class="__tesimg">
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                            <p class="__tesp1">Andyson Utomudo</p>
                            <p class="__tesp2">Senior backend developer, Findworka Pro</p>
                        </div>
                    </div>
                </div>
            </carousel> -->
            <!-- <div class="row">
				<div class="col-lg-4 col-md-4 col-sm-4">
					<div class="__tescard">
						<p class="__tesp">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
						<div class="row">
							<div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
								<img src="../assets/img/hackathon.png" class="__tesimg">
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
								<p class="__tesp1">First name, last name</p>
								<p class="__tesp2">Position, Company</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<div class="__tescard1">
						<p class="__tesp">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
						<div class="row">
							<div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
								<img src="../assets/img/hackathon.png" class="__tesimg">
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
								<p class="__tesp1">First name, last name</p>
								<p class="__tesp2">Position, Company</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<div class="__tescard2">
						<p class="__tesp">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
						<div class="row">
							<div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
								<img src="../assets/img/hackathon.png" class="__tesimg">
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
								<p class="__tesp1">First name, last name</p>
								<p class="__tesp2">Position, Company</p>
							</div>
						</div>
					</div>
				</div>
			</div> -->
        </div>

        <!-- <div class="__hirbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-laptop"></i>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Build your product</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                                <router-link to="/build" class="btn __startbtn">Start now</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <div class="__midline hidden-xs"></div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-code"></i>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Hire a developer</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">Hire from our network of pre-vetted and handpicked programming talents for your full-time and contract engagements.</p>
                                <a href="https://hire.findworka.com" target="_blank" class="btn __startbtn">Hire a dev</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>


<script>
import navbar from '../components/navbar';
import carousel from 'vue-owl-carousel';
import loadProjects from '../assets/js/projects.json'

export default {
    components: { carousel,
    navbar,
    },

    name:'projects',
    data(){
        return {
            projects: ''
        }
    },
    mounted() {
        this.projects = loadProjects
        // this.selectedProject = this.$store.state.found
        // console.log(selectedProject)

    },
    methods: {
        findProject(slug){
            let array = this.projects
            for (let i=0; i < array.length; i++) {
                if (array[i].slug === slug) {
                    this.$store.state.found = i
                    console.log(this.$store.state.found)
                }
            this.$router.push('/portfolio')
            }
        }
    }
}
</script>

<style scoped>
@import '../assets/css/home';

</style>


// WEBPACK FOOTER //
// src/components/home.vue